import type { Components } from '@mui/material'

export const MuiFormControl: Components['MuiFormControl'] = {
  defaultProps: {
    variant: 'outlined',
    fullWidth: true,
    size: 'small',
  },
}
